export default __webpack_public_path__ + "static/media/Nunito-LightItalic.051d648a.woff";